var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"visible":!_vm.connected,"title":_vm.$t('disconnected'),"centered":"","hide-header-close":false,"hide-footer":true,"no-close-on-backdrop":true,"no-close-on-esc":true}},[_c('p',{staticClass:"my-4"},[_c('i',{staticClass:"fa fa-network-wired fa-lg mx-4"}),_vm._v(" "+_vm._s(_vm.$t("errors.disconnected"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }